import { notifications } from '@mantine/notifications';

/**
 * Toasts per the handoff: 5s auto-close, errors persist. Position (bottom-right on
 * desktop, top on mobile) is set on the <Notifications> provider in main.tsx.
 */
const AUTO_CLOSE_MS = 5000;

export const toast = {
  ok(title: string, message?: string) {
    notifications.show({ title, message, color: 'success', autoClose: AUTO_CLOSE_MS });
  },
  info(title: string, message?: string) {
    notifications.show({ title, message, color: 'info', autoClose: AUTO_CLOSE_MS });
  },
  error(title: string, message?: string) {
    notifications.show({ title, message, color: 'danger', autoClose: false });
  },
};
